"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetRuntimePlanSchema = exports.PresetRuntimeContractSchema = exports.PresetRuntimeComponentDefaultSchema = exports.PresetRuntimeComponentPropPolicySchema = exports.PresetRuntimeContentStudioFieldPolicySchema = exports.PresetRuntimeStarterContentPolicySchema = exports.PresetRuntimeDataSourceRequirementSchema = exports.PresetRuntimeGeneratedRouteSchema = exports.PresetStarterContentModeSchema = exports.PresetSeoStrategySchema = exports.PresetEditorSurfaceSchema = exports.PresetDataSourcePurposeSchema = void 0;
exports.normalizeRuntimeRoutePath = normalizeRuntimeRoutePath;
exports.getRuntimeRoutePathDepth = getRuntimeRoutePathDepth;
exports.resolvePresetGeneratedRoutePath = resolvePresetGeneratedRoutePath;
exports.getPresetRuntimeContract = getPresetRuntimeContract;
exports.getPresetRuntimeContractForPage = getPresetRuntimeContractForPage;
exports.getPresetRuntimePlan = getPresetRuntimePlan;
exports.getPresetRuntimePlanForPage = getPresetRuntimePlanForPage;
exports.listPresetRuntimeDataSourceRequirements = listPresetRuntimeDataSourceRequirements;
exports.listPresetRuntimeSectionSourceKeys = listPresetRuntimeSectionSourceKeys;
exports.getPresetRuntimeComponentStylePresetId = getPresetRuntimeComponentStylePresetId;
exports.listAppBaseOperationalContentRoles = listAppBaseOperationalContentRoles;
exports.listAppBaseOperationalContentSourceKeys = listAppBaseOperationalContentSourceKeys;
exports.getContentStudioFieldPolicyForRole = getContentStudioFieldPolicyForRole;
exports.getAppBaseContentStudioFieldPolicy = getAppBaseContentStudioFieldPolicy;
const zod_1 = require("zod");
const app_base_config_1 = require("./app-base-config");
const page_presets_1 = require("./page-presets");
const standard_app_base_databases_1 = require("./standard-app-base-databases");
exports.PresetDataSourcePurposeSchema = zod_1.z.enum([
    'page',
    'section',
    'translation',
    'styling',
]);
exports.PresetEditorSurfaceSchema = zod_1.z.enum([
    'wizard',
    'content',
    'translations',
    'design',
    'builder',
    'repair',
]);
exports.PresetSeoStrategySchema = zod_1.z.enum([
    'page-route',
    'content-row',
    'form-route',
    'internal-route',
]);
exports.PresetStarterContentModeSchema = zod_1.z.enum([
    'starter-row',
    'defer-user-content',
    'system-managed',
]);
exports.PresetRuntimeGeneratedRouteSchema = page_presets_1.PagePresetGeneratedChildRouteSchema.extend({
    path: zod_1.z.string().min(1),
    depth: zod_1.z.number().int().nonnegative(),
}).strict();
exports.PresetRuntimeDataSourceRequirementSchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    role: app_base_config_1.AppBaseDataSourceRoleSchema,
    contentModel: app_base_config_1.AppBaseContentModelSchema,
    label: zod_1.z.string().min(1).optional(),
    purpose: exports.PresetDataSourcePurposeSchema,
})
    .strict();
exports.PresetRuntimeStarterContentPolicySchema = zod_1.z
    .object({
    sourceKey: zod_1.z.string().min(1),
    role: app_base_config_1.AppBaseDataSourceRoleSchema,
    contentModel: app_base_config_1.AppBaseContentModelSchema,
    mode: exports.PresetStarterContentModeSchema,
    editableRows: zod_1.z.boolean(),
})
    .strict();
exports.PresetRuntimeContentStudioFieldPolicySchema = zod_1.z
    .object({
    role: app_base_config_1.AppBaseDataSourceRoleSchema,
    defaultVisibleFields: zod_1.z.array(zod_1.z.string().min(1)),
    advancedFields: zod_1.z.array(zod_1.z.string().min(1)),
    systemFields: zod_1.z.array(zod_1.z.string().min(1)),
})
    .strict();
exports.PresetRuntimeComponentPropPolicySchema = zod_1.z.enum([
    'workflow-form-config',
]);
exports.PresetRuntimeComponentDefaultSchema = zod_1.z
    .object({
    componentType: zod_1.z.string().min(1),
    props: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    stylePresetId: zod_1.z.string().min(1).nullable(),
    motionSpec: app_base_config_1.MotionSpecSchema.nullable(),
    propPolicies: zod_1.z.array(exports.PresetRuntimeComponentPropPolicySchema),
})
    .strict();
exports.PresetRuntimeContractSchema = zod_1.z
    .object({
    presetKey: zod_1.z.string().min(1),
    page: zod_1.z
        .object({
        routeKind: app_base_config_1.RouteKindSchema,
        audience: app_base_config_1.AudienceSchema,
        templateKey: zod_1.z.string().min(1),
        collectionRole: zod_1.z.string().min(1).nullable(),
        publicationModel: app_base_config_1.PublicationModelSchema,
    })
        .strict(),
    dataSources: zod_1.z.array(exports.PresetRuntimeDataSourceRequirementSchema),
    components: zod_1.z
        .object({
        sections: zod_1.z.array(page_presets_1.PageSectionPresetSchema),
        allowedComponentTypes: zod_1.z.array(zod_1.z.string().min(1)),
        defaults: zod_1.z.array(exports.PresetRuntimeComponentDefaultSchema),
    })
        .strict(),
    navigation: zod_1.z
        .object({
        enabled: zod_1.z.boolean(),
    })
        .strict(),
    listing: zod_1.z
        .object({
        search: zod_1.z.boolean(),
        pagination: zod_1.z.enum(['none', 'load-more', 'pages']),
    })
        .strict(),
    seo: zod_1.z
        .object({
        strategy: exports.PresetSeoStrategySchema,
        robotsIndex: zod_1.z.boolean(),
        manualOverrides: zod_1.z.literal('advanced-only'),
    })
        .strict(),
    operations: zod_1.z
        .object({
        contentStudioRoles: zod_1.z.array(app_base_config_1.AppBaseDataSourceRoleSchema),
        contentStudioFieldPolicies: zod_1.z.array(exports.PresetRuntimeContentStudioFieldPolicySchema),
        translations: zod_1.z
            .object({
            enabled: zod_1.z.boolean(),
            contentSourceKey: zod_1.z.string().min(1).nullable(),
            translationSourceKey: zod_1.z.string().min(1),
        })
            .strict(),
        customCss: zod_1.z
            .object({
            enabled: zod_1.z.boolean(),
            defaultSurface: zod_1.z.literal('design'),
            advancedSurface: zod_1.z.literal('builder-design'),
        })
            .strict(),
    })
        .strict(),
    health: zod_1.z
        .object({
        requiredSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
        sectionSourceKeys: zod_1.z.array(zod_1.z.string().min(1)),
    })
        .strict(),
    ux: zod_1.z
        .object({
        defaultVisibleModes: zod_1.z.array(exports.PresetEditorSurfaceSchema),
        advancedModes: zod_1.z.array(exports.PresetEditorSurfaceSchema),
        repairMode: zod_1.z.literal('issue-gated'),
    })
        .strict(),
    generatedChildRoutes: zod_1.z.array(page_presets_1.PagePresetGeneratedChildRouteSchema),
})
    .strict();
exports.PresetRuntimePlanSchema = zod_1.z
    .object({
    presetKey: zod_1.z.string().min(1),
    page: exports.PresetRuntimeContractSchema.shape.page,
    requiredDataSources: zod_1.z.array(exports.PresetRuntimeDataSourceRequirementSchema),
    generatedRoutes: zod_1.z.array(exports.PresetRuntimeGeneratedRouteSchema),
    componentPlan: exports.PresetRuntimeContractSchema.shape.components,
    starterContentPolicy: zod_1.z.array(exports.PresetRuntimeStarterContentPolicySchema),
    contentStudioFieldPolicies: zod_1.z.array(exports.PresetRuntimeContentStudioFieldPolicySchema),
    seoPolicy: exports.PresetRuntimeContractSchema.shape.seo,
    operationalSurfaceRoles: zod_1.z.array(app_base_config_1.AppBaseDataSourceRoleSchema),
    translationPlan: exports.PresetRuntimeContractSchema.shape.operations.shape.translations,
    healthExpectations: exports.PresetRuntimeContractSchema.shape.health,
    uxPolicy: exports.PresetRuntimeContractSchema.shape.ux,
})
    .strict();
const PAGE_PRESET_DATA_SOURCE_ROLES = new Set(app_base_config_1.AppBaseDataSourceRoleSchema.options);
const CONTENT_STUDIO_ROLE_ORDER = [
    'content',
    'users',
    'topics',
    'clusters',
    'forms',
];
const CONTENT_STUDIO_ROLE_SET = new Set(CONTENT_STUDIO_ROLE_ORDER);
const CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS = {
    clusters: ['slug', 'title', 'description', 'status', 'order'],
    topics: ['slug', 'title', 'description', 'status', 'order'],
    content: [
        'slug',
        'title',
        'description',
        'summary',
        'body',
        'image',
        'imageAlt',
        'ctaLabel',
        'ctaUrl',
        'featured',
        'author',
        'readTime',
        'status',
        'publishedAt',
        'scheduledAt',
    ],
    users: [
        'slug',
        'title',
        'role',
        'email',
        'description',
        'avatar',
        'status',
        'order',
    ],
    forms: ['title', 'formConfig', 'submitLabel', 'successMessage', 'status'],
};
const CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS_BY_CONTENT_MODEL = {
    'legal-page': ['title', 'description', 'body', 'locale', 'status'],
    'intranet-dashboard-item': [
        'title',
        'description',
        'summary',
        'itemType',
        'workStatus',
        'priority',
        'owner',
        'value',
        'target',
        'unit',
        'trend',
        'category',
        'deadline',
        'updatedAt',
        'status',
    ],
};
const CONTENT_STUDIO_SYSTEM_FIELDS = {
    clusters: ['clusterId'],
    topics: ['topicId', 'clusterId'],
    users: ['userId', 'workspaceUserId', 'tenantUserId'],
    content: ['clusterId', 'topicId', 'internalLinkRowIds'],
    forms: ['formKey'],
};
const CONTENT_STUDIO_SYSTEM_FIELDS_BY_CONTENT_MODEL = {
    'legal-page': ['slug', 'updatedAt', 'canonical', 'noindex'],
    'intranet-dashboard-item': [
        'slug',
        'body',
        'image',
        'imageAlt',
        'featured',
        'readTime',
        'publishedAt',
        'scheduledAt',
        'canonical',
        'hreflangGroup',
        'locale',
        'requiredLocale',
        'noindex',
        'clusterId',
        'topicId',
        'internalLinkRowIds',
    ],
};
const SEARCH_ENABLED_ROUTE_KINDS = new Set(['index', 'dashboard']);
const PAGINATED_ROUTE_KINDS = new Set(['index', 'dashboard']);
const APP_BASE_HEADER_DEFAULTS_BY_TEMPLATE = {
    landing: {
        subtitle: 'A focused starting point for your site.',
    },
    'legal-page': {
        title: 'Legal',
        subtitle: 'Legal information for this app.',
    },
    'blog-index': {
        title: 'Journal',
        subtitle: 'Latest updates, articles, and announcements.',
    },
    'blog-post': {
        title: 'Article',
        subtitle: 'Read the full update.',
    },
    'intranet-dashboard': {
        title: 'Dashboard',
        subtitle: 'Internal updates, tables, and operational overview.',
    },
    'workflow-form': {
        title: 'Request Form',
        subtitle: 'Collect structured submissions from your audience.',
    },
    custom: {
        title: 'Page',
        subtitle: 'Custom page content.',
    },
};
const APP_BASE_FOOTER_DEFAULTS = {
    showNavigation: true,
};
const DEFAULT_MOTION_BY_COMPONENT_TYPE = {
    'hero-banner': {
        id: 'hero-enter',
        trigger: 'on-enter',
        preset: 'slide-up',
        durationMs: 520,
        delayMs: 0,
        staggerMs: 0,
        easing: 'emphasized',
        reducedMotionPolicy: 'fade',
    },
    'card-grid': {
        id: 'card-grid-enter',
        trigger: 'on-enter',
        preset: 'fade-in',
        durationMs: 360,
        delayMs: 80,
        staggerMs: 60,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
    'article-list': {
        id: 'list-enter',
        trigger: 'on-enter',
        preset: 'slide-up',
        durationMs: 320,
        delayMs: 60,
        staggerMs: 40,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
    'form-view': {
        id: 'form-enter',
        trigger: 'on-enter',
        preset: 'scale-in',
        durationMs: 260,
        delayMs: 0,
        staggerMs: 0,
        easing: 'ease-out',
        reducedMotionPolicy: 'static',
    },
    'single-article': {
        id: 'article-enter',
        trigger: 'on-enter',
        preset: 'fade-in',
        durationMs: 280,
        delayMs: 0,
        staggerMs: 0,
        easing: 'standard',
        reducedMotionPolicy: 'fade',
    },
};
const LANDING_COMPONENT_DEFAULTS = {
    'app-base-navigation': {
        visible: true,
    },
    'hero-banner': {
        eyebrow: 'Deine App. Klar aufgebaut.',
        subtitleField: 'description',
        aiHint: 'Gestalte diese Landing Page mit der KI weiter oder füge passende Bereiche hinzu.',
        suggestedSections: [
            'Features',
            'Bento',
            'Carousel',
            'Kennzahlen',
            'Referenzen',
            'FAQ',
            'Call-to-Action',
        ],
    },
    'markdown-renderer': {
        bodyField: 'body',
    },
    'card-grid': {
        teaserSource: 'child-routes',
        gridLabel: 'Entdecke die App',
        showImage: false,
        showTags: false,
    },
    'app-base-footer': {
        showNavigation: true,
    },
};
const LEGAL_PAGE_COMPONENT_DEFAULTS = {
    'single-article': {
        showBackLink: false,
        showMeta: false,
        renderMarkdown: true,
        preferRuntimeLocale: true,
    },
};
const INTRANET_DASHBOARD_COMPONENT_DEFAULTS = {
    'kpi-card': {
        label: 'Aktive Arbeitsbereiche',
        aggregationType: 'count',
        valueColumn: '',
        format: 'number',
    },
    'bar-chart': {
        groupByColumn: 'workStatus',
        valueColumn: 'value',
        aggregationType: 'count',
        orientation: 'horizontal',
        height: 260,
    },
    'line-chart': {
        xColumn: 'updatedAt',
        yColumns: ['value', 'target'],
        width: 720,
        height: 260,
    },
    'table-view': {
        visibleColumns: [
            'title',
            'workStatus',
            'priority',
            'owner',
            'deadline',
            'value',
            'target',
        ],
        compact: false,
    },
};
const DEFAULT_STYLE_BY_COMPONENT_TYPE = {
    'hero-banner': 'landing-hero',
    'card-grid': 'feature-cards',
    'article-list': 'blog-cards',
    'single-article': 'blog-cards',
    'form-view': 'forms',
    'kpi-card': 'feature-cards',
    'bar-chart': 'feature-cards',
    'line-chart': 'feature-cards',
    'table-view': 'feature-cards',
};
function isPresetDataSourceRole(value) {
    return PAGE_PRESET_DATA_SOURCE_ROLES.has(value);
}
function createRuntimeDataSourceRequirement(preset, sourceKey, purpose) {
    if (!isPresetDataSourceRole(sourceKey))
        return null;
    const role = sourceKey;
    const contentModel = preset.sourceContentModels[role];
    if (!contentModel) {
        throw new Error(`Page preset ${preset.presetKey} must declare a content model for ${role}`);
    }
    return {
        sourceKey: (0, app_base_config_1.createAppBaseDataSourceKey)({ role, contentModel }),
        role,
        contentModel,
        label: createRuntimeDataSourceLabel(preset, contentModel),
        purpose,
    };
}
function createRuntimeDataSourceLabel(preset, contentModel) {
    if (contentModel === 'app-base-user')
        return 'Users';
    if (preset.templateKey === 'intranet-dashboard' &&
        contentModel === 'intranet-dashboard-item') {
        return 'Dashboard Work Items';
    }
    return undefined;
}
function deriveRuntimeDataSources(preset) {
    const requirements = [];
    for (const sourceKey of preset.requiredSourceKeys) {
        const requirement = createRuntimeDataSourceRequirement(preset, sourceKey, 'page');
        if (requirement)
            requirements.push(requirement);
    }
    for (const section of preset.defaultSections) {
        for (const sourceKey of section.sourceKeys) {
            const requirement = createRuntimeDataSourceRequirement(preset, sourceKey, 'section');
            if (requirement)
                requirements.push(requirement);
        }
    }
    const seen = new Set();
    return requirements.filter(requirement => {
        const key = `${requirement.role}:${requirement.contentModel}`;
        if (seen.has(key))
            return false;
        seen.add(key);
        return true;
    });
}
function deriveContentStudioRoles(requirements) {
    const roles = new Set(requirements
        .map(requirement => requirement.role)
        .filter(role => CONTENT_STUDIO_ROLE_SET.has(role)));
    return CONTENT_STUDIO_ROLE_ORDER.filter(role => roles.has(role));
}
function listContentStudioFields(role, contentModel) {
    const baseFields = standard_app_base_databases_1.STANDARD_APP_BASE_DATABASE_COLUMN_DEFS[role].map(def => def.name);
    const relationFields = standard_app_base_databases_1.STANDARD_APP_BASE_DATABASE_RELATION_DEFS.filter(spec => (0, standard_app_base_databases_1.standardAppBaseDatabaseRelationAppliesToSource)(spec, {
        role,
        contentModel,
    })).map(spec => spec.sourceName);
    return [...new Set([...baseFields, ...relationFields])];
}
function createContentStudioFieldPolicy(role, contentModel = (0, app_base_config_1.getDefaultAppBaseContentModelForRole)(role)) {
    if (!CONTENT_STUDIO_ROLE_SET.has(role))
        return null;
    const contentRole = role;
    const allFields = listContentStudioFields(contentRole, contentModel);
    const allFieldSet = new Set(allFields);
    const systemFields = (CONTENT_STUDIO_SYSTEM_FIELDS_BY_CONTENT_MODEL[contentModel] ??
        CONTENT_STUDIO_SYSTEM_FIELDS[contentRole] ??
        []).filter(field => allFieldSet.has(field));
    const defaultVisibleFields = (CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS_BY_CONTENT_MODEL[contentModel] ??
        CONTENT_STUDIO_DEFAULT_VISIBLE_FIELDS[contentRole] ??
        allFields).filter(field => allFieldSet.has(field));
    const defaultSet = new Set(defaultVisibleFields);
    const systemSet = new Set(systemFields);
    const advancedFields = allFields.filter(field => !defaultSet.has(field) && !systemSet.has(field));
    return exports.PresetRuntimeContentStudioFieldPolicySchema.parse({
        role,
        defaultVisibleFields,
        advancedFields,
        systemFields,
    });
}
function deriveContentStudioFieldPolicies(requirements) {
    return requirements
        .filter(requirement => CONTENT_STUDIO_ROLE_SET.has(requirement.role))
        .map(requirement => createContentStudioFieldPolicy(requirement.role, requirement.contentModel))
        .filter((policy) => policy !== null);
}
function deriveSeoStrategy(preset) {
    if (preset.routeKind === 'detail')
        return 'content-row';
    if (preset.routeKind === 'form')
        return 'form-route';
    if (preset.audience === 'internal')
        return 'internal-route';
    return 'page-route';
}
function deriveComponentDefaultProps(preset, componentType) {
    const props = {};
    if (componentType === 'app-base-header') {
        Object.assign(props, APP_BASE_HEADER_DEFAULTS_BY_TEMPLATE[preset.templateKey]);
    }
    if (componentType === 'app-base-footer') {
        Object.assign(props, APP_BASE_FOOTER_DEFAULTS);
    }
    if (preset.templateKey === 'landing') {
        Object.assign(props, LANDING_COMPONENT_DEFAULTS[componentType]);
    }
    if (preset.templateKey === 'legal-page') {
        Object.assign(props, LEGAL_PAGE_COMPONENT_DEFAULTS[componentType]);
    }
    if (preset.templateKey === 'intranet-dashboard') {
        Object.assign(props, INTRANET_DASHBOARD_COMPONENT_DEFAULTS[componentType]);
    }
    return props;
}
function deriveComponentPropPolicies(preset, componentType) {
    return preset.templateKey === 'workflow-form' && componentType === 'form-view'
        ? ['workflow-form-config']
        : [];
}
function deriveComponentDefaults(preset) {
    const componentTypes = new Set([
        'app-base-header',
        'app-base-footer',
        ...preset.defaultSections.map(section => section.componentType),
    ]);
    return [...componentTypes].map(componentType => exports.PresetRuntimeComponentDefaultSchema.parse({
        componentType,
        props: deriveComponentDefaultProps(preset, componentType),
        stylePresetId: DEFAULT_STYLE_BY_COMPONENT_TYPE[componentType] ?? null,
        motionSpec: DEFAULT_MOTION_BY_COMPONENT_TYPE[componentType] ?? null,
        propPolicies: deriveComponentPropPolicies(preset, componentType),
    }));
}
function deriveRuntimeContract(preset) {
    const requirements = deriveRuntimeDataSources(preset);
    const sourceKeyByRole = new Map(requirements.map(requirement => [requirement.role, requirement.sourceKey]));
    const sectionSourceKeys = [
        ...new Set(preset.defaultSections.flatMap(section => section.sourceKeys.map(sourceKey => isPresetDataSourceRole(sourceKey)
            ? (sourceKeyByRole.get(sourceKey) ?? sourceKey)
            : sourceKey))),
    ];
    const contentStudioRoles = deriveContentStudioRoles(requirements);
    const contentStudioFieldPolicies = deriveContentStudioFieldPolicies(requirements);
    const contentSource = requirements.find(requirement => requirement.role === 'content') ?? null;
    const navigationEnabled = preset.defaultSections.some(section => section.componentType === 'app-base-navigation');
    return exports.PresetRuntimeContractSchema.parse({
        presetKey: preset.presetKey,
        page: {
            routeKind: preset.routeKind,
            audience: preset.audience,
            templateKey: preset.templateKey,
            collectionRole: preset.collectionRole,
            publicationModel: preset.publicationModel,
        },
        dataSources: requirements,
        components: {
            sections: preset.defaultSections,
            allowedComponentTypes: preset.allowedComponentTypes,
            defaults: deriveComponentDefaults(preset),
        },
        navigation: {
            enabled: navigationEnabled,
        },
        listing: {
            search: SEARCH_ENABLED_ROUTE_KINDS.has(preset.routeKind),
            pagination: PAGINATED_ROUTE_KINDS.has(preset.routeKind)
                ? 'load-more'
                : 'none',
        },
        seo: {
            strategy: deriveSeoStrategy(preset),
            robotsIndex: preset.audience === 'public',
            manualOverrides: 'advanced-only',
        },
        operations: {
            contentStudioRoles,
            contentStudioFieldPolicies,
            translations: {
                enabled: contentSource !== null,
                contentSourceKey: contentSource?.sourceKey ?? null,
                translationSourceKey: 'translations',
            },
            customCss: {
                enabled: true,
                defaultSurface: 'design',
                advancedSurface: 'builder-design',
            },
        },
        health: {
            requiredSourceKeys: requirements.map(requirement => requirement.sourceKey),
            sectionSourceKeys,
        },
        ux: {
            defaultVisibleModes: ['wizard', 'content', 'translations', 'design'],
            advancedModes: ['builder'],
            repairMode: 'issue-gated',
        },
        generatedChildRoutes: preset.generatedChildRoutes ?? [],
    });
}
function normalizeRuntimeRoutePath(path) {
    const trimmed = path.trim();
    if (!trimmed || trimmed === '/')
        return '/';
    const withLeadingSlash = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return withLeadingSlash.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
}
function getRuntimeRoutePathDepth(path) {
    const normalized = normalizeRuntimeRoutePath(path);
    if (normalized === '/')
        return 0;
    return normalized.split('/').filter(Boolean).length;
}
function resolvePresetGeneratedRoutePath(parentPath, childRoute) {
    const normalizedParentPath = normalizeRuntimeRoutePath(parentPath);
    const normalizedPattern = childRoute.pathPattern.trim();
    if (normalizedPattern.startsWith('/')) {
        return normalizeRuntimeRoutePath(normalizedPattern);
    }
    const suffix = normalizedPattern.replace(/^\/+/, '').replace(/\/+$/, '');
    if (!suffix)
        return normalizedParentPath;
    const prefix = normalizedParentPath === '/' ? '' : normalizedParentPath;
    return normalizeRuntimeRoutePath(`${prefix}/${suffix}`);
}
function deriveStarterContentMode(requirement) {
    if (requirement.role === 'submissions')
        return 'system-managed';
    if (requirement.role === 'content' ||
        requirement.role === 'users' ||
        requirement.role === 'topics' ||
        requirement.role === 'clusters' ||
        requirement.role === 'forms') {
        return 'starter-row';
    }
    return 'defer-user-content';
}
function deriveStarterContentPolicy(requirements) {
    return requirements.map(requirement => ({
        sourceKey: requirement.sourceKey,
        role: requirement.role,
        contentModel: requirement.contentModel,
        mode: deriveStarterContentMode(requirement),
        editableRows: requirement.role !== 'submissions',
    }));
}
function deriveRuntimePlan(preset, parentPath) {
    const contract = deriveRuntimeContract(preset);
    return exports.PresetRuntimePlanSchema.parse({
        presetKey: contract.presetKey,
        page: contract.page,
        requiredDataSources: contract.dataSources,
        generatedRoutes: contract.generatedChildRoutes.map(childRoute => {
            const path = resolvePresetGeneratedRoutePath(parentPath, childRoute);
            return {
                ...childRoute,
                path,
                depth: getRuntimeRoutePathDepth(path),
            };
        }),
        componentPlan: contract.components,
        starterContentPolicy: deriveStarterContentPolicy(contract.dataSources),
        contentStudioFieldPolicies: contract.operations.contentStudioFieldPolicies,
        seoPolicy: contract.seo,
        operationalSurfaceRoles: contract.operations.contentStudioRoles,
        translationPlan: contract.operations.translations,
        healthExpectations: contract.health,
        uxPolicy: contract.ux,
    });
}
function getPresetRuntimeContract(presetKey) {
    const preset = (0, page_presets_1.getPagePreset)(presetKey);
    return preset ? deriveRuntimeContract(preset) : null;
}
function getPresetRuntimeContractForPage(page) {
    const preset = (0, page_presets_1.getPagePresetForPage)(page);
    return preset ? deriveRuntimeContract(preset) : null;
}
function getPresetRuntimePlan(presetKey, parentPath = '/') {
    const preset = (0, page_presets_1.getPagePreset)(presetKey);
    return preset ? deriveRuntimePlan(preset, parentPath) : null;
}
function getPresetRuntimePlanForPage(page) {
    const preset = (0, page_presets_1.getPagePresetForPage)(page);
    return preset ? deriveRuntimePlan(preset, page.path) : null;
}
function listPresetRuntimeDataSourceRequirements(presetKey) {
    return getPresetRuntimeContract(presetKey)?.dataSources ?? [];
}
function listPresetRuntimeSectionSourceKeys(presetKey) {
    return getPresetRuntimeContract(presetKey)?.health.sectionSourceKeys ?? [];
}
function getPresetRuntimeComponentStylePresetId(componentType) {
    for (const presetKey of Object.keys(page_presets_1.PAGE_PRESETS)) {
        const contract = getPresetRuntimeContract(presetKey);
        const defaultConfig = contract?.components.defaults.find(item => item.componentType === componentType && item.stylePresetId);
        if (defaultConfig?.stylePresetId)
            return defaultConfig.stylePresetId;
    }
    return null;
}
function listAppBaseOperationalContentRoles(appBaseConfig) {
    const dataSources = getAppBaseRuntimeDataSources(appBaseConfig);
    const roles = new Set();
    for (const key of listAppBaseOperationalContentSourceKeys(appBaseConfig)) {
        const source = dataSources[key];
        if (source)
            roles.add(source.role);
    }
    return CONTENT_STUDIO_ROLE_ORDER.filter(role => roles.has(role));
}
function listAppBaseOperationalContentSourceKeys(appBaseConfig) {
    const dataSources = getAppBaseRuntimeDataSources(appBaseConfig);
    const sourceKeys = new Set();
    const pageDeclaredKeys = new Set();
    for (const page of appBaseConfig.pages ?? []) {
        const contract = getPresetRuntimeContractForPage(page);
        // A page whose preset brings no source schema (configured Apps, package
        // Apps) declares its own sources. Keep the page reference authoritative
        // and exclude system-only roles.
        if (!contract || contract.dataSources.length === 0) {
            for (const key of page.dataSourceKeys ?? []) {
                const source = dataSources[key];
                if (source && CONTENT_STUDIO_ROLE_SET.has(source.role)) {
                    sourceKeys.add(key);
                    pageDeclaredKeys.add(key);
                }
            }
            continue;
        }
        const operationalRoles = new Set(contract.operations.contentStudioRoles);
        for (const requirement of contract.dataSources) {
            if (!operationalRoles.has(requirement.role))
                continue;
            if (dataSources[requirement.sourceKey]) {
                sourceKeys.add(requirement.sourceKey);
            }
        }
        for (const sourceKey of page.dataSourceKeys ?? []) {
            const source = dataSources[sourceKey];
            if (!source || !operationalRoles.has(source.role))
                continue;
            sourceKeys.add(sourceKey);
        }
    }
    const hasPageDeclaredSources = appBaseConfig.pages.some(page => (page.dataSourceKeys?.length ?? 0) > 0 &&
        !getPresetRuntimeContractForPage(page)?.dataSources.length);
    if (sourceKeys.size === 0 && !hasPageDeclaredSources && dataSources.content) {
        sourceKeys.add('content');
    }
    // The standard source of a preset, called like its role, gives way to a
    // specific source of that role. A source a page declared itself stays,
    // whatever it is called.
    for (const sourceKey of [...sourceKeys]) {
        const source = dataSources[sourceKey];
        const role = source?.role;
        if (!role || sourceKey === role || pageDeclaredKeys.has(role))
            continue;
        sourceKeys.delete(role);
    }
    return [...sourceKeys].sort((a, b) => {
        const sourceA = dataSources[a];
        const sourceB = dataSources[b];
        const roleA = sourceA?.role ?? 'content';
        const roleB = sourceB?.role ?? 'content';
        const roleOrder = CONTENT_STUDIO_ROLE_ORDER.indexOf(roleA) -
            CONTENT_STUDIO_ROLE_ORDER.indexOf(roleB);
        return roleOrder || a.localeCompare(b);
    });
}
function getContentStudioFieldPolicyForRole(role) {
    return createContentStudioFieldPolicy(role);
}
function getAppBaseRuntimeDataSources(appBaseConfig) {
    return (appBaseConfig.dataSources ?? (0, app_base_config_1.resolveAppBaseBindingDataSources)(appBaseConfig));
}
function getAppBaseContentStudioFieldPolicy(appBaseConfig, sourceKey) {
    const source = getAppBaseRuntimeDataSources(appBaseConfig)[sourceKey];
    if (!source)
        return null;
    for (const page of appBaseConfig.pages ?? []) {
        const contract = getPresetRuntimeContractForPage(page);
        if (!contract)
            continue;
        const sourceBelongsToPage = page.dataSourceKeys.includes(sourceKey) ||
            contract.dataSources.some(requirement => requirement.sourceKey === sourceKey);
        if (!sourceBelongsToPage)
            continue;
        const policy = contract.operations.contentStudioFieldPolicies.find(candidate => candidate.role === source.role) ?? null;
        if (policy)
            return policy;
    }
    return createContentStudioFieldPolicy(source.role, source.contentModel);
}
